const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Is this URL parameter actually an id we could have issued?
 *
 * Guards a query or an API call against a hand-edited or truncated URL, so a
 * junk id fails here rather than as a confusing error from the server. Several
 * pages keep a private copy of this that predates the shared one; they should
 * migrate to this when they are next touched.
 */
export function isUuidParam(value: string | null | undefined): boolean {
  return typeof value === "string" && UUID_RE.test(value.trim());
}
